import { createBrowserRouter } from 'react-router-dom';
import { AppRoutesEnum } from '@routing/routesEnum';
import Layout from '@layout/Layout';
import Home from '@pages/home/Home';
import About from '@pages/about/About';
import Faq from '@pages/faq/Faq';
import Contact from '@pages/contact/Contact';
import Gallery from '@pages/gallery/Gallery';
import Order from '@pages/order/Order';
import OrderCat from '@pages/order-cat/OrderCat';
import CatProbe from '@pages/cat-probe/CatProbe';
import Partners from '@pages/partners/Partners';
import PartnersRegistration from '@pages/partners-registration/PartnersRegistration';
import PartnersOrder from '@pages/partners-order/PartnersOrder';
import NotFoundPage from '@pages/not-found/NotFoundPage';
import SalesNetwork from '@pages/sales-network/SalesNetwork';
//import FormPlaceholder from '@pages/form-placeholder/FormPlaceholder';
import ThankYou from '@pages/thank-you/ThankYou';



export const router = createBrowserRouter([
	{
		path: AppRoutesEnum.basePath,
		element: <Layout />,
		children: [
			{
				index: true,
				element: <Home />
			},
			{
				path: AppRoutesEnum.about,
				element: <About />
			},
			{
				path: AppRoutesEnum.order,
				element: <Order />
			},
			{
				path: AppRoutesEnum.orderSelect,
				element: <Order />
			},
			{
				path: AppRoutesEnum.catOrder,
				element: <OrderCat />
			},
			{
				path: AppRoutesEnum.gallery,
				element: <Gallery />
			},
			{
				path: AppRoutesEnum.partners,
				element: <Partners />
			},
			{
				path: AppRoutesEnum.partnersRegistration,
				element: <PartnersRegistration />
			},
			{
				path: AppRoutesEnum.partnersOrder,
				element: <PartnersOrder />
			},
			{
				path: AppRoutesEnum.faq,
				element: <Faq />
			},
			{
				path: AppRoutesEnum.contact,
				element: <Contact />
			},
			{
				path: AppRoutesEnum.salesNetwork,
				element: <SalesNetwork />
			},
			{
				path: AppRoutesEnum.thankYouOrder,
				element: <ThankYou />
			},
			{
				path: AppRoutesEnum.thankYouRegistration,
				element: <ThankYou registration={true} />
			},
			/*{
				path: AppRoutesEnum.formPlaceholder,
				element: <FormPlaceholder />
			},*/
		]
	},
	{
		element: <Layout />,
		children: [
			{
				path: "*",
				element: <NotFoundPage />
			}
		]
	}
]);